<template>
  <div>
    <h3 style="color:#143150"><b>{{start}}. ウェブマルウェアの拡散検出 (WMDS)</b></h3><br>
      <b-row style="padding-left:25px;">
        <b-col>
          <h4><b>{{start}}.1 概要</b></h4>
          <b-row style="padding-left:25px;">
            <b-col><br>
              <h5><b>{{start}}.1.1. 基本情報</b></h5>
              <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                <tbody>
                  <tr>
                    <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">Username</th>
                    <th style="background-Color:#3D63BA; text-align: center; background-Color:#f0f3f5;">{{auth.profile.username}}</th>
                  </tr>
                  <tr>
                    <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">period</th>
                    <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{from}} ~ {{to}}</th>
                  </tr>
                </tbody>
              </table>
              <h5><b>{{start}}.1.2. 契約状況</b></h5>
              <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                <tbody>
                  <tr>
                    <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">Status</th>
                    <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Count</th>
                  </tr>
                  <tr>
                    <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Contracted</th>
                    <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{wmds_summary && wmds_summary.wmds_status && wmds_summary.wmds_status || 0}}</th>
                  </tr>
                </tbody>
              </table>
              <h5><b>{{start}}.1.3. セキュリティに関わるイベントの総数</b></h5>
              <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                <tbody>
                  <tr>
                    <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">Events</th>
                    <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Count</th>
                  </tr>
                  <tr>
                    <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Detected</th>
                    <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{wmds_summary && wmds_summary.total_number_of_security_events && wmds_summary.total_number_of_security_events || 0}}</th>
                  </tr>
                </tbody>
              </table>
              <h5><b>{{start}}.1.4. WMDSの状況（ドメイン）</b></h5>
              <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                <tbody>
                  <tr>
                    <th class="table-f1" style="width:40%" colspan="5">Domain</th>
                  </tr>
                  <tr>
                    <th class="table-f1" style="width:40%" colspan="2">Name</th>
                    <th class="table-f1" >FQDN</th>
                    <th class="table-f1" >Status</th>
                    <th class="table-f1" >Deleted</th>
                  </tr>
                  <tr v-for="WMDS_5_1_4 in wmds_summary.domain_and_wmds_status" :key="WMDS_5_1_4.id">
                    <th class="border-f1" colspan="2">{{WMDS_5_1_4.name}}</th>
                    <th class="border-f1">{{WMDS_5_1_4.fqdn}}</th>
                    <th class="border-f1">
                      <b-badge :variant="WMDS_5_1_4.is_del ? '' : 'success'">{{WMDS_5_1_4.is_del ? 'Off' : 'On'}}</b-badge>
                    </th>
                    <th class="border-f1">
                      <span v-if="WMDS_5_1_4.is_del"> {{ WMDS_5_1_4.deleted_at | datetime }} </span>
                      <span v-else>-</span>
                    </th>
                  </tr>
                  <tr v-if="wmds_summary.domain_and_wmds_status.length < 1">
                    <th class="border-f1" colspan="2">N/A</th>
                    <th class="border-f1">N/A</th>
                    <th class="border-f1">N/A</th>
                    <th class="border-f1">N/A</th>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
          <h4><b>{{start}}.2 監視状況  </b></h4>
          <b-row style="padding-left:25px;">
            <b-col><br>
              <h5><b>{{start}}.2.1. マルウェア検知総数</b></h5>
              <b-row style="padding-left:25px;">
                <b-col>
                  <h5><b>{{start}}.2.1.1. マルウェア検知数（日次）</b></h5>
                  <line-chart :chartData="WMDS_Daily_Detecting"></line-chart>
                </b-col>
              </b-row>
              <hr>
              <h5><b>{{start}}.2.2. 個別ドメインに対する検知（日次）</b></h5>
              <b-row v-for="(WMDS_5_2_2_1, index) in wmds_recent.domain_check_table" :key="WMDS_5_2_2_1.id" style="padding-left:25px;">
                <b-col>
                  <h5 v-if="WMDS_5_2_2_1.deleted_at !== '-'"><b>{{start}}.2.2.{{index + 1}} 日次マルウェア検知数  ({{WMDS_5_2_2_1.fqdn}}) - Deleted {{WMDS_5_2_2_1.deleted_at | date}}</b></h5>
                  <h5 v-else><b>{{start}}.2.2.1. Daily detection ({{WMDS_5_2_2_1.fqdn}})</b></h5>
                  <line-chart :chartData="WMDS_5_2_2_1.chart"></line-chart>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <line-chart v-if="wmds_recent.domain_check_table.length < 1" :chartData="DEFAULT_CHART_DATA"></line-chart>
                </b-col>
              </b-row>
              <hr>
              <h5><b>{{start}}.2.3.  マルウェア検知（ドメイン毎）</b></h5>
              <b-row style="padding-left:25px;">
                <b-col>
                  <h5><b>{{start}}.2.3.1. 検知イベントの総数 <small class="float-right">List of last 50</small></b></h5> </b></h5>
                  <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                    <tbody>
                      <tr style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">
                        <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;" rowspan="2">Domain Name (FQDN)</th>
                        <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Events</th>
                      </tr>
                      <tr style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">
                        <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Detected</th>
                      </tr>
                      <tr style="border:1px solid; text-align: center;" v-for="WMDS_5_2_3_1 in wmds_summary.total_number_per_domain" :key="WMDS_5_2_3_1.id">
                        <th style="border:1px solid; text-align: center;">{{WMDS_5_2_3_1.name}} ({{WMDS_5_2_3_1.fqdn}})</th>
                        <th style="border:1px solid; text-align: center;">{{WMDS_5_2_3_1.dt_cnt}}</th>
                      </tr>
                      <tr style="border:1px solid; text-align: center;" v-if="wmds_summary.total_number_per_domain.length < 1">
                        <th style="border:1px solid; text-align: center;">N/A</th>
                        <th style="border:1px solid; text-align: center;">N/A</th>
                      </tr>
                    </tbody>
                  </table>
                  <h5><b>{{start}}.2.3.2. 検知イベント（ト―タル） <small class="float-right">List of last 10</small> </b></h5>
                  <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                    <tbody>
                      <tr>
                        <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Name</th>
                        <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Code</th>
                        <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">URL</th>
                      </tr>
                      <tr v-for="WMDS_5_2_4_2_Total in wmds_summary.events_total" :key="WMDS_5_2_4_2_Total.index">
                        <th class="p-2" style="border:1px solid; text-align: center;">{{WMDS_5_2_4_2_Total.name}}</th>
                        <!-- <th class="p-2" style="border:1px solid; text-align: center;">{{WMDS_5_2_4_2_Total.fqdn}}</th> -->
                        <th class="p-2" style="border:1px solid; text-align: left; word-break:break-all;">{{WMDS_5_2_4_2_Total.code | truncate(100) }}</th>
                        <th class="p-2" style="border:1px solid; text-align: left; word-break:break-all;">{{WMDS_5_2_4_2_Total.url | truncate(100)}}</th>
                      </tr>
                      <tr v-if="wmds_summary.events_total.length < 1">
                        <th style="border:1px solid; text-align: center;">N/A</th>
                        <th style="border:1px solid; text-align: center;">N/A</th>
                        <th style="border:1px solid; text-align: center;">N/A</th>
                      </tr>
                    </tbody>
                  </table>
                  <div v-for="(WMDS_5_2_3_2, index) in wmds_summary.events_domain" :key="WMDS_5_2_3_2.id">
                    <div v-if="WMDS_5_2_3_2.rs_list.length > 1">
                      <h5><b>{{start}}.2.3.{{index + 2}} 検知イベント ({{WMDS_5_2_3_2.fqdn}}) <small class="float-right">List of last 10</small> </b></h5>
                      <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                        <tbody>
                          <tr>
                            <!-- <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Name</th> -->
                            <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Code</th>
                            <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">URL</th>
                          </tr>

                          <tr v-for="WMDS_5_2_3_3_1 in WMDS_5_2_3_2.rs_list" :key="WMDS_5_2_3_3_1.id">
                            <!-- <th class="p-2" style="border:1px solid; text-align: center;" v-if="WMDS_5_2_3_3_1">{{WMDS_5_2_3_3_1.name}}</th> -->
                            <th class="p-2" style="border:1px solid; text-align: left;" v-if="WMDS_5_2_3_3_1">{{WMDS_5_2_3_3_1.code | truncate(100) }}</th>
                            <th class="p-2" style="border:1px solid; text-align: left;" v-if="WMDS_5_2_3_3_1">{{WMDS_5_2_3_3_1.url | truncate(100)}}</th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- 코드가 있는 경우 내용이 있음 -->
                    <div v-else-if="WMDS_5_2_3_2.rs_list.code">
                      <h5><b>{{start}}.2.3.{{index + 2}} Events ({{WMDS_5_2_3_2.fqdn}}) <small class="float-right">List of last 10</small> </b></h5>
                      <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                        <tbody>
                          <tr>
                            <!-- <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Name</th> -->
                            <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Code</th>
                            <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">URL</th>
                          </tr>

                          <tr v-for="WMDS_5_2_3_3_1 in WMDS_5_2_3_2.rs_list" :key="WMDS_5_2_3_3_1.id">
                            <!-- <th class="p-2" style="border:1px solid; text-align: center;" v-if="WMDS_5_2_3_3_1">{{WMDS_5_2_3_3_1.name}}</th> -->
                            <th class="p-2" style="border:1px solid; text-align: left;" v-if="WMDS_5_2_3_3_1">{{WMDS_5_2_3_3_1.code | truncate(100) }}</th>
                            <th class="p-2" style="border:1px solid; text-align: left;" v-if="WMDS_5_2_3_3_1">{{WMDS_5_2_3_3_1.url | truncate(100)}}</th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- 코드가 없는 경우 내용이 없음 -->
                    <div v-else>
                      <h5><b>{{start}}.2.3.{{index + 2}} Events ({{WMDS_5_2_3_2.fqdn}}) <small class="float-right">List of last 10</small> </b></h5>
                      <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                        <tbody>
                          <tr>
                            <!-- <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Name</th> -->
                            <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Code</th>
                            <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">URL</th>
                          </tr>
                          <tr>
                            <!-- <th class="p-2" style="border:1px solid; text-align: center;">N/A</th> -->
                            <th class="p-2" style="border:1px solid;">{{WMDS_5_2_3_2.rs_list.code ? WMDS_5_2_3_2.rs_list.code : 'N/A' }}</th>
                            <th class="p-2" style="border:1px solid;">{{WMDS_5_2_3_2.rs_list.url ? WMDS_5_2_3_2.rs_list.url : 'N/A'}}</th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <h4><b>{{start}}.3  管理状況</b></h4>
          <b-row style="padding-left:25px;">
            <b-col>
              <h5><b>{{start}}.3.1. マルウェア検知のパターン</b></h5>
              <b-row style="padding-left:25px;">
                <b-col>
                  <h5><b>{{start}}.3.1.1. 更新回数</b></h5>
                  <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                    <tbody>
                      <tr>
                        <th colspan="2" style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">
                          Pattern
                        </th>
                      </tr>
                      <tr>
                        <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Total</th>
                        <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">This Month</th>
                      </tr>
                      <tr>
                        <th style="border:1px solid; background-Color:#f0f3f5; text-align: center;">{{wmds_summary && wmds_summary.number_of_update && wmds_summary.number_of_update.total || 0}}</th>
                        <th style="border:1px solid; background-Color:#f0f3f5; text-align: center;">{{wmds_summary && wmds_summary.number_of_update && wmds_summary.number_of_update.month || 0}}</th>
                        <!-- 이번달 -->
                      </tr>
                    </tbody>
                  </table>
                  <!-- <h5><b>{{start}}.3.1.2. Daily update</b></h5>
                  <line-chart :chartData="WMDS_Daily_Pattern"></line-chart>  -->
                  <hr>
                  <h5><b>{{start}}.3.1.2. 更新されたパターンの詳細 <small class="float-right">List of last 10</small></b></h5>
                  <table style="word-break:break-all; width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                    <tbody>
                      <tr>
                        <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:100px;">Date</th>
                        <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Level</th>
                        <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Code</th>
                      </tr>
                      <tr v-for="WMDS_5_4_1_3 in wmds_summary.updated_pattern_description" :key="WMDS_5_4_1_3.id">
                        <th class="p-2" style="border:1px solid; background-Color:#f0f3f5; text-align: center;">{{WMDS_5_4_1_3.create_at | date}}</th>
                        <th class="p-2" style="border:1px solid; background-Color:#f0f3f5; text-align: center;">{{codes.WMDS_PATTRN_LEVEL[WMDS_5_4_1_3.level]}}</th>
                        <th class="p-2" style="border:1px solid; background-Color:#f0f3f5; text-align: left;">{{WMDS_5_4_1_3.code}}</th>
                      </tr>
                      <tr v-if="wmds_summary.updated_pattern_description.length < 1">
                        <th style="border:1px solid; background-Color:#f0f3f5; text-align: center;">N/A</th>
                        <th style="border:1px solid; background-Color:#f0f3f5; text-align: center;">N/A</th>
                        <th style="border:1px solid; background-Color:#f0f3f5; text-align: center;">N/A</th>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
  </div>
</template>

<script>

// chart
import lineChart from '../../chart/MainChart';
import BarChart from '../../chart/BarChart';
import DoughnutChart from '../../chart/DoughnutChart';
import StackedVerticalBarChart from '../../chart/StackedVerticalBarChart'

// lib
import auth from '@/f1/service/auth';
import codes from '@/f1/codes';
import _ from 'lodash'
import Custom from '@/f1/service/custom';

export default {
  name:'ReportWMDS',
  props: [
    'start',
    'end',
    'from',
    'to',
    'wmds_recent',
    'wmds_summary',
    'WMDS_Daily_Detecting_Total',
    'WMDS_Daily_Detecting_Domain',
    'WMDS_Daily_Detecting',
    'WMDS_Daily_Pattern',
  ],
  components: {
    // chart
    lineChart,
    DoughnutChart,
    BarChart,
    StackedVerticalBarChart,

  },
  data: () => {
    return {
      custom : Custom.custom_default,
      codes,
      auth,
      DEFAULT_CHART_DATA : {
        labels: [],
        datasets: [
          {
            label: 'No have value',
            backgroundColor: '#f87979',
            data: []
          }
        ]
      }
    }
  },
  computed: {
  },
  methods: {
    // Regex	Hash	URL	SSDEEP	Obfuscation
    // wsfinder_rule(setting) { return _.map((JSON.parse(setting).rule || []), r => r.toLowerCase()) },
  },
  created: function() {
    console.log(`[${this.custom.slogan}]Report.wmds.vue`, `created`);
  },
  destroyed: function() { console.log(`[${this.custom.slogan}]Report.wmds.vue`, `destroyed`); },
  mounted: function() {
    this.custom = Custom.setting()
    console.log(`[${this.custom.slogan}]Report.wmds.vue`, `mounted`);
  },
}
</script>
